import {
  Grid,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";

const timeRangeArray = [
  'Today', 'This Week', 'This Month', 'This Year', 'All Time',
];

const DashboardHeader = ({ timeRange, handleTimeRangeChange }) => {
  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 2,
        mt: 2.5,
        mb: 1
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography
          variant="h5"
          sx={{ color: '#1e293b' }}
        >
          <strong>Dashboard</strong>
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
        >
          Track, monitor, and manage all key metrics.
        </Typography>
      </Box>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <Select
          value={timeRange}
          onChange={handleTimeRangeChange}
          displayEmpty
          sx={{
            borderRadius: 2,
            backgroundColor: '#ffffff',
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#334155',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#cbd5e1',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#94a3b8',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1976d2',
            },
          }}
        >
          {timeRangeArray.map((data, index) => (
            <MenuItem value={data} key={index}>{data}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default DashboardHeader;